import { render, staticRenderFns } from "./DelegatesMapLegend.vue?vue&type=template&id=024e1684"
import script from "./DelegatesMapLegend.vue?vue&type=script&lang=js"
export * from "./DelegatesMapLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports